import { useEffect } from 'react';

/** The agent palette is a document class shared by every stage entry. */
export function useStageAppearance(appearance: 'light' | 'dark' | 'auto') {
  useEffect(() => {
    const root = document.documentElement;
    const apply = (dark: boolean) => {
      root.classList.toggle('dark', dark);
      root.classList.toggle('light', !dark);
      const canvasColor = getComputedStyle(root).backgroundColor;
      const themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (canvasColor && themeColorMeta) {
        themeColorMeta.setAttribute('content', canvasColor);
      }
    };
    if (appearance !== 'auto') {
      apply(appearance === 'dark');
      return;
    }
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    apply(media.matches);
    const onChange = (event: MediaQueryListEvent) => apply(event.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [appearance]);
}
